import { SubscribeBannerProps } from '@jbhi-fi/components/src/FooterLayout/Subscribe/SubscribeBanner';

export type DefaultFooterProps = {
  subscribeProps: SubscribeBannerProps;
  storeLocation: string;
};

export const defaultArgs: DefaultFooterProps = {
  subscribeProps: {
    enabled: window.Jbhifi?.footerConfig?.isSubscribeEnabled ?? false,
    offerText: 'Get instant deals and exclusive offers!',
    disclaimer:
      'By providing your email you agree that your personal information will be handled in accordance with our ',
    mailingListId: window.Jbhifi.klaviyoMailingListId,
  },
  storeLocation: window.Jbhifi?.storeLocation || 'AU',
};
